import { FormattedMessage } from 'react-intl';

import {
  PlayerGameScoreProjectionGrade,
  So5FixtureEvent,
  Sport,
} from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { Switch } from '@sorare/core/src/components/search/Switch';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { glossary } from '@sorare/core/src/lib/glossary';
import { PlayerSearchViewAttributes } from '@sorare/core/src/lib/playerSearchView';

import { Grade } from '#src/components/player/Grade/index.tsx';
import { useManagePlayerSearchView } from '#src/searchCommonPlayer/StatsManager/useManagePlayerSearchView.ts';

const availableProjectionBySportGrade: Record<Sport, So5FixtureEvent[]> = {
  [Sport.FOOTBALL]: [So5FixtureEvent.CLASSIC],
  [Sport.NBA]: [],
  [Sport.BASEBALL]: [],
};

export const ProjectionGrades = () => {
  const {
    flags: { useEnableProjectionGrade = true },
  } = useFeatureFlags();
  const { statsManager, updatePlayerSearchViewAttribute } =
    useManagePlayerSearchView();
  const { sport } = useSportContext();

  const projectionsGrade =
    statsManager[PlayerSearchViewAttributes.PROJECTION_GRADE];
  const availableProjectionsGrade = availableProjectionBySportGrade[sport];
  const onProjectionsChange = (input: So5FixtureEvent[]) =>
    updatePlayerSearchViewAttribute(
      PlayerSearchViewAttributes.PROJECTION_GRADE,
      input
    );

  if (availableProjectionsGrade.length === 0 || !useEnableProjectionGrade)
    return null;

  return (
    <Vertical>
      <LabelM color="var(--c-nd-600)">
        <FormattedMessage {...glossary.projections} />
      </LabelM>
      {availableProjectionsGrade.map(so5FixtureEvent => (
        <Switch
          key={so5FixtureEvent}
          checked={projectionsGrade.includes(so5FixtureEvent)}
          onChange={() =>
            onProjectionsChange(
              projectionsGrade.includes(so5FixtureEvent)
                ? projectionsGrade.filter(s => s !== so5FixtureEvent)
                : [...projectionsGrade, so5FixtureEvent]
            )
          }
          label={
            <Horizontal>
              <Grade
                size={3}
                projection={{
                  __typename: 'PlayerGameScoreProjection',
                  id: '1',
                  grade: PlayerGameScoreProjectionGrade.A,
                  reliabilityBasisPoints: 10000,
                }}
              />
              <FormattedMessage defaultMessage="Next Game Week Power Grade" />
            </Horizontal>
          }
        />
      ))}
    </Vertical>
  );
};
